<label class="ap-radio-button">
    <input
        #input
        class="ap-radio-button__input"
        type="radio"
        data-testid="input"
        [attr.disabled]="isDisabled ? isDisabled : null"
        [attr.aria-invalid]="control ? control.invalid : null"
        [attr.aria-describedby]="getAriaDescribedBy() ? getAriaDescribedBy() : null"
        [attr.value]="value()"
        [attr.name]="name()"
        [attr.checked]="isChecked ? isChecked : null"
        (change)="radioChange($event)"
        (blur)="radioBlur()"
    />

    <div class="ap-radio-button__radio"></div>
    <div class="ap-radio-button__container">
        @if (label()) {
            <span class="ap-radio-button__label" data-testid="label" [innerHtml]="label()"></span>
        }
        @if (subTitle()) {
            <span class="ap-radio-button__subtitle" data-testid="subTitle" [innerHtml]="subTitle()"></span>
        }
    </div>
</label>
